import { useState, useEffect } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { getRole } from "../api/users";

export default function SuperPrivateRoute() {
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkSuperAdmin = async () => {
      const token = localStorage.getItem("access_token");
      if (!token) {
        setLoading(false);
        return;
      }

      try {
        const roleData = await getRole();
        setIsSuperAdmin(roleData.role === "superadmin");
      } catch (error) {
        console.error("Error checking role:", error);
      } finally {
        setLoading(false);
      }
    };
    checkSuperAdmin();
  }, []);

  if (loading) return null;
  return isSuperAdmin ? <Outlet /> : <Navigate to="/login" replace />;
}
